import {
  Button,
  Card,
  Checkbox,
  CheckboxChangeEvent,
  Col,
  Flex,
  Form,
  Grid,
  Input,
  Row,
  Select,
  SelectProps,
  Tooltip,
} from "antd";
import { Cascader } from "antd-mobile";
import { CheckListValue } from "antd-mobile/es/components/check-list";
import React, { useEffect, useRef, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { CustomMessage } from "../../../../components";
import { useLocalStorage } from "../../../../context/useLocalStorage";
import { contactMethod } from "../../../../enumerations/contactMethod";
import localStorageKey from "../../../../enumerations/localStorageKey";
import {
  useCheckout,
  useGetPaymentMethod,
  usePay,
} from "../../../../hooks/Checkout/checkout.hooks";
import {
  PaymentParams,
  PaymentResponse,
  PayResponse,
} from "../../../../hooks/Checkout/data";
import { PhoneCodeResponse } from "../../../../hooks/PhoneCode/data";
import { useGetAreaCode } from "../../../../hooks/PhoneCode/hooks";
import { SearchResponse } from "../../../../hooks/Search/data";

import { useLocation, useNavigate } from "react-router-dom";
import AlertCircle from "../../../../assets/images/icons/AlertCircle";
import { H6, P2 } from "../../../../components/NormalFonts";
import { useAuth } from "../../../../context/AuthContext";
import apiErrorCode from "../../../../enumerations/apiErrorCode";
import contentTypeEnum from "../../../../enumerations/contentTypeEnum";
import { useCheckCoupon } from "../../../../hooks/Coupon/coupon.hooks";
import { CheckCouponResponse } from "../../../../hooks/Coupon/data";
import { OrderDetailsType } from "../../../../hooks/Order/data";
import { moneyFormat } from "../../../../plugins/numberFormat";
import { pushGtag } from "../../../../plugins/utils";
import {
  EmailFormat,
  InputRequired,
} from "../../../../validations/validations";
import { discountTypeEnum } from "../../enumerations/discountType";
import PaymentItem from "./components/PaymentItem";
import { PaymentProps } from "./data";
import styles from "./style.module.scss";
import "./styles.scss";

const Payment: React.FC<PaymentProps> = ({
  searchResult = [],
  loadingResult = {},
  onChangeStep,
  setPaymentNumber = () => {},
  paymentNumber,
  totalAmount,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { useBreakpoint } = Grid;
  const location = useLocation();
  const { nickname } = location.state || {};
  const screens = useBreakpoint();
  const DEFAULT_AREA_CODE = "+886";
  const DEFAULT_CONTACT_TYPE = "LINE";

  const { data: paymentList, error: errorPayment } = useGetPaymentMethod({});
  const { data: phoneArea } = useGetAreaCode({});
  const { mutate: checkout } = useCheckout();
  const { mutate: pay } = usePay();
  const [loading, setLoading] = useState<boolean>(false);
  const [openSelect, setOpenSelect] = useState<boolean>(false);
  const [openPopup, setOpenPopup] = useState<boolean>(false);
  const [areaCodeValue, setAreaCodeValue] = useState<CheckListValue[]>([]);
  const [userInfo, setUserInfo] = useLocalStorage(
    localStorageKey.USER_INFO,
    undefined
  );
  const [useRegisterEmail, setUseRegisterEmail] = useState<boolean>(false);

  const [paymentOptions, setPaymentOptions] = useState<SelectProps["options"]>(
    []
  );
  const [areaOptions, setAreaOptions] = useState<any[]>([]);
  const [contactOptions, setContactOptions] = useState<SelectProps["options"]>(
    []
  );

  const { setLoginForm, setAuthModalVisible, isAuthenticated } = useAuth();
  const [checkPaymentAgreement, setCheckPaymentAgreement] =
    useState<boolean>(false);
  const [checkInfoAgreement, setCheckInfoAgreement] = useState<boolean>(true);

  const [isPaymentUnchecked, setIsPaymentUnchecked] = useState<boolean>(false);
  const [isInfoUnchecked, setIsInfoUnchecked] = useState<boolean>(false);

  const couponCodeChecked = useRef<boolean>(false);
  const [couponCode, setCouponCode] = useState<string>("");
  const [totalPrice, setTotalPrice] = useState<number>(0);
  const [discountAmount, setDiscountAmount] = useState<number>(0);
  const [finalTotalAmount, setFinalTotalAmount] = useState<number>(0);
  const [currentCouponData, setCurrentCouponData] = useState<
    CheckCouponResponse | undefined
  >(undefined);

  const { refetch: refetchCheckCoupon, isFetching: isCheckingCoupon } =
    useCheckCoupon({ coupon_code: couponCode }, { enabled: false });

  const openHtmlInCurrentTab = (htmlString: string) => {
    const blob = new Blob([htmlString], { type: "text/html" });
    const url = URL.createObjectURL(blob);
    // navigate("/record", { replace: true });
    // window.open(url, "_blank");
    window.location.href = url;

    // Optional: revoke later (browser might already do this on unload)
    setTimeout(() => URL.revokeObjectURL(url), 5000);
  };

  const handleCheckCoupon = () => {
    if (isAuthenticated === false) {
      setAuthModalVisible(true);
      return;
    }
    refetchCheckCoupon().then((data: any) => {
      console.debug("data", data);
      if (data.status === "error") {
        if (
          data.error.data.result.code === apiErrorCode.TOKEN_ERROR ||
          data.error.data.result.code === apiErrorCode.AUTH_FAIELD_ERROR
        ) {
          setAuthModalVisible(true);
        }
        CustomMessage({
          alertMessage: t([
            `error.${data.error.data.result.code}`,
            data.error.data.result.message,
          ]),
          alertType: "error",
        });
      } else if (data.status === "success") {
        console.debug("data.data.dicount", data.data.discount_value);
        console.debug("totalPrice", totalPrice);
        if (
          data.data.discount_type === discountTypeEnum.MONEY &&
          data.data.discount_value > (totalPrice || 0)
        ) {
          form.setFields([
            {
              name: "coupon_code",
              errors: [t("error.discount")],
            },
          ]);
          console.debug("error", "error discount to big");
          return;
        }
        setCurrentCouponData(data.data);
        couponCodeChecked.current = true;
      }
    });
  };

  const handleCouponCodeChange = (e: any) => {
    setCouponCode(e.target.value);
    setCurrentCouponData(undefined);
    couponCodeChecked.current = false;
  };

  useEffect(() => {
    if (currentCouponData) {
      console.debug("currentCouponData", currentCouponData);
      if (currentCouponData.discount_type === discountTypeEnum.MONEY) {
        setDiscountAmount(currentCouponData.discount_value);
        setFinalTotalAmount(totalPrice - currentCouponData.discount_value);
      } else {
        setDiscountAmount(
          totalPrice * (currentCouponData.discount_value / 100)
        );
        setFinalTotalAmount(
          totalPrice * (1 - currentCouponData.discount_value / 100)
        );
      }
    }
  }, [currentCouponData, isCheckingCoupon]);

  useEffect(() => {
    setContactOptions(
      contactMethod.map((contact: any) => {
        return {
          label: t(`normal.contact.${contact.value}`),
          value: contact.value,
        };
      })
    );
    form.setFieldsValue({
      contact_type: contactMethod[0].value,
    });
  }, []);

  useEffect(() => {
    if (!paymentList || paymentList.length <= 0) return;
    const _payment = paymentList.map((payment: PaymentResponse) => {
      return {
        label: payment.name,
        value: payment.payment_method_code,
      };
    });
    form.setFieldsValue({
      payment_method_code: paymentList[0].payment_method_code,
    });
    setPaymentOptions(_payment);
  }, [paymentList]);

  const onFinish = async (value: any) => {
    console.debug("currentCouponData", currentCouponData);
    if (isAuthenticated === false) {
      setAuthModalVisible(true);
      return;
    }

    setIsInfoUnchecked(!checkInfoAgreement);
    setIsPaymentUnchecked(!checkPaymentAgreement);
    if (!checkInfoAgreement || !checkPaymentAgreement) return;

    setLoading(true);
    if (!paymentNumber) {
      const request = {
        // company_code: process.env.REACT_APP_COMPANY_CODE,
        total_order_amount: totalPrice,
        orderer_name: value.orderer_name,
        orderer_email: value.orderer_email,
        orderer_area_code: value.orderer_area_code,
        // orderer_area_code: "866",
        orderer_mobile: value.orderer_mobile,
        orderer_contact: [
          {
            contact_type: value.contact_type,
            contact_value: value.contact_value,
          },
        ],
        payment_method_code: value.payment_method_code,
        order_list: searchResult,
        coupon_code: currentCouponData ? value.coupon_code : "",
        discount_amount: currentCouponData ? discountAmount : 0,
        final_total_amount: finalTotalAmount,
      };
      await checkout(
        { params: request },
        {
          onSuccess: async (data: any) => {
            pushGtag({
              event: "go_to_payment",
            });

            const response: PayResponse = data?.data?.data?.payment_detail;
            setLoading(false);
            switch (response.content_type) {
              case contentTypeEnum.HTML:
                openHtmlInCurrentTab(response.content);
                break;

              default:
                break;
            }
          },
          onError: (error: any) => {
            if (
              error.data.result.code === apiErrorCode.TOKEN_ERROR ||
              error.data.result.code === apiErrorCode.AUTH_FAIELD_ERROR
            ) {
              setAuthModalVisible(true);
            }
            CustomMessage({
              alertMessage: t([
                `error.${error.data.result.code}`,
                error.data.result.message,
              ]),
              alertType: "error",
            });
            setLoading(false);
          },
        }
      );
    } else {
      const request: PaymentParams = {
        payment_method_code: value.payment_method_code,
        order_payment_number: paymentNumber,
        total_price: Number(totalAmount),
        orderer_name: value.orderer_name,
        orderer_area_code: value.orderer_area_code,
        orderer_mobile: value.orderer_mobile,
        orderer_email: value.orderer_email,
      };
      console.debug("request", request);
      pay(
        { params: request },
        {
          onSuccess: (data: any) => {
            const response: PayResponse = data.data.data;
            setLoading(false);
            switch (response.content_type) {
              case contentTypeEnum.HTML:
                openHtmlInCurrentTab(response.content);
                break;
              default:
                break;
            }
          },
          onError: (error: any) => {
            console.debug("error", error);
            setLoading(false);
            CustomMessage({
              alertMessage: t([
                `error.${error.data.result.code}`,
                error.data.result.message,
              ]),
              alertType: "error",
            });
          },
        }
      );
    }
  };

  const onFinishFailed = (errorInfo: any) => {
    // 如果有驗證錯誤，跳轉到第一個錯誤的字段
    if (errorInfo.errorFields && errorInfo.errorFields.length > 0) {
      const firstErrorField = errorInfo.errorFields[0];

      form.scrollToField(firstErrorField.name, {
        behavior: "smooth",
        block: "center",
        inline: "nearest",
      });
    }
  };

  const onCheckRegisterEmailChange = (e: CheckboxChangeEvent) => {
    setUseRegisterEmail(e.target.checked);
    if (e.target.checked === true) {
      form.setFieldsValue({ orderer_email: userInfo?.email });
    } else {
      form.setFieldsValue({ orderer_email: undefined });
    }
  };

  const onAgreementCheckChange = (e: CheckboxChangeEvent) => {
    setCheckPaymentAgreement(e.target.checked);
    setIsPaymentUnchecked(!e.target.checked);
  };
  const onInfoCheckChange = (e: CheckboxChangeEvent) => {
    setCheckInfoAgreement(e.target.checked);
    setIsInfoUnchecked(!e.target.checked);
  };

  useEffect(() => {
    if (!phoneArea || phoneArea.length <= 0) return;
    const _area = phoneArea.map((area: PhoneCodeResponse) => {
      return {
        label: `+${area.phoneCode}`,
        value: area.phoneCode,
      };
    });
    const areaCode = userInfo?.area_code
      ? userInfo.area_code.toString()
      : DEFAULT_AREA_CODE;
    form.setFieldsValue({
      orderer_area_code: areaCode,
    });
    setAreaCodeValue([areaCode]);
    setAreaOptions(_area);
  }, [phoneArea]);

  useEffect(() => {
    if (!userInfo) return;
    form.setFieldsValue({
      orderer_mobile: userInfo?.mobile,
      contact_type:
        userInfo?.contact && userInfo.contact.length > 0
          ? userInfo?.contact[0].contact_type
          : DEFAULT_CONTACT_TYPE,
      contact_value:
        userInfo?.contact && userInfo.contact.length > 0
          ? userInfo?.contact[0].contact_value
          : undefined,
      orderer_name: userInfo?.nickname,
      orderer_email: userInfo?.email,
    });
    if (userInfo?.email) {
      setUseRegisterEmail(true);
    }
  }, [userInfo]);

  const handleClickAreaCode = () => {
    if (screens.sm) {
      setOpenSelect(!openSelect);
      setOpenPopup(false);
    } else {
      setOpenSelect(false);
      setOpenPopup(true);
    }
  };

  const handleConfirmAreaCode = (val: CheckListValue[]) => {
    console.debug(val);
    if (val.length > 0) {
      form.setFieldsValue({
        orderer_area_code: val[0],
      });
      setAreaCodeValue(val);
    }
  };

  const areaSelector = (
    <Form.Item name={"orderer_area_code"} style={{ marginBottom: 0 }}>
      <Select
        style={{ width: 120 }}
        options={areaOptions}
        open={openSelect}
        onClick={handleClickAreaCode}
        onChange={(val) => setAreaCodeValue([val])}
      />
    </Form.Item>
  );

  const contactSelector = (
    <Form.Item name={"contact_type"} style={{ marginBottom: 0 }}>
      <Select style={{ width: 120 }} options={contactOptions} />
    </Form.Item>
  );
  const renderContactExtra = () => {
    return (
      <>
        <Tooltip
          classNames={{ root: "custom-tooltip" }}
          placement={"bottomRight"}
          align={{ offset: [-50, 0], autoArrow: true }}
          styles={{
            body: {
              borderRadius: 4,
              background: "#FFF",
              boxShadow: "0px 2px 6px 0px rgba(0, 0, 0, 0.10)",
              padding: "2px 16px",
              width: 322,
            },
            root: {
              background: "#FFF",
            },
          }}
          title={
            <P2 color="var(--Neutral-dark-70)">
              <Trans
                i18nKey={"order.hint"}
                components={{
                  ol: <ol />,
                  li: <li />,
                }}
              />
            </P2>
          }
        >
          <AlertCircle style={{ fontSize: 20, color: "var(--primary)" }} />
        </Tooltip>
        <div></div>
      </>
    );
  };

  const renderPaymentItem = () => {
    let visibleData: SearchResponse[] | OrderDetailsType[] = searchResult;
    // console.debug("visibleData", visibleData);
    return visibleData?.map(
      (result: SearchResponse | OrderDetailsType, index: number) => {
        return (
          <PaymentItem
            order={result}
            key={`order_${index}`}
            nickname={nickname}
          />
        );
      }
    );
  };

  const renderDiscount = () => {
    if (paymentNumber) return;
    return (
      <Card
        style={{ width: "100%" }}
        variant={"borderless"}
        size={screens.sm ? "default" : "small"}
        title={<div>{t("search.payment.useCoupon")}</div>}
      >
        <Row gutter={screens.md ? [16, 14] : [0, 4]}>
          <Col span={screens.md ? 21 : 24}>
            <Form.Item
              name="coupon_code"
              label={t("search.payment.coupon")}
              // rules={[
              //   {
              //     validator: () => {
              //       if (discountAmount >= totalPrice) {
              //         throw new Error(
              //           `API value (${discountAmount}) must be less than total price (${totalPrice})`
              //         );
              //       }

              //       return Promise.resolve();
              //     },
              //   },
              // ]}
            >
              <Input
                placeholder={t("search.payment.coupon.placeholder")}
                value={couponCode}
                onChange={handleCouponCodeChange}
                allowClear
              />
            </Form.Item>
          </Col>
          <Col
            span={screens.md ? 3 : 24}
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Button
              type="primary"
              size="small"
              style={{ width: "100%", height: screens.md ? 46 : 36 }}
              onClick={handleCheckCoupon}
              disabled={!couponCode || couponCodeChecked.current}
              loading={isCheckingCoupon}
            >
              {t("search.payment.coupon.check")}
            </Button>
          </Col>
          {currentCouponData && (
            <Col span={24}>
              <div
                className={styles.couponResult}
                style={{
                  marginTop: screens.md ? 0 : 34,
                  justifyContent: screens.md ? "flex-end" : "space-between",
                }}
              >
                <Flex
                  vertical
                  justify="flex-end"
                  gap={8}
                  style={{ textAlign: screens.md ? "end" : "start" }}
                >
                  <P2 color="var(--text-content-3)">
                    {t("search.payment.coupon.totalPrice")}
                  </P2>
                  <P2 color="var(--text-content-3)">
                    {t("search.payment.coupon.discountPrice")}
                  </P2>
                  <P2
                    color="var(--text-content-3)"
                    style={{
                      height: 28,
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {t("search.payment.coupon.finalPrice")}
                  </P2>
                </Flex>
                <Flex
                  vertical
                  justify="flex-end"
                  gap={8}
                  style={{ textAlign: "end" }}
                >
                  <P2 weight="medium" color="var(--text-content-1)">
                    {`${t(
                      `currency.${process.env.REACT_APP_CURRENCY}`
                    )} ${moneyFormat(totalPrice)}`}
                  </P2>
                  <P2 weight="medium" color="var(--text-content-1)">
                    {`- ${t(
                      `currency.${process.env.REACT_APP_CURRENCY}`
                    )} ${moneyFormat(discountAmount)}`}
                  </P2>
                  <H6 weight="heavy" color="var(--primary)">
                    {`${t(
                      `currency.${process.env.REACT_APP_CURRENCY}`
                    )} ${moneyFormat(finalTotalAmount)}`}
                  </H6>
                </Flex>
              </div>
            </Col>
          )}
        </Row>
      </Card>
    );
  };

  useEffect(() => {
    if (searchResult.length > 0) {
      const newTotalPrice: number = (searchResult as OrderDetailsType[]).reduce(
        (acc: number, val: SearchResponse | OrderDetailsType) => {
          return acc + val.total_price;
        },
        0
      );
      setTotalPrice(newTotalPrice);
      setFinalTotalAmount(newTotalPrice);
    }
  }, [searchResult]);

  return (
    <Form
      autoComplete={"off"}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      form={form}
      requiredMark={false}
      layout={"vertical"}
    >
      <div
        className={`${styles.paymentContainer} ${
          screens.sm ? "" : styles.mobile
        }`}
      >
        {renderPaymentItem()}

        {/* 使用優惠卷 */}
        {renderDiscount()}

        {/* 主要聯絡人資訊 */}
        <Card
          style={{ width: "100%" }}
          variant={"borderless"}
          size={screens.sm ? "default" : "small"}
          title={<div>{t("checkout.contactperson.title")}</div>}
          extra={renderContactExtra()}
        >
          <Row gutter={screens.sm ? [16, 28] : [0, 0]}>
            <Col span={screens.sm ? 12 : 24}>
              <Form.Item
                id="orderer_name"
                name="orderer_name"
                label={t("checkout.nickname.title")}
                rules={[InputRequired(t, "checkout.nickname.title")]}
              >
                <Input placeholder={t("checkout.nickname.hint")} />
              </Form.Item>
            </Col>
            <Col span={screens.sm ? 12 : 24}>
              <Form.Item
                id="contact_value"
                name="contact_value"
                label={t("checkout.contact.title")}
                rules={[
                  InputRequired(t, "checkout.contact.title"),
                  {
                    pattern: /^[\x20-\x7E]*$/, // ASCII range: space to tilde
                    message: t("error.contact.format"),
                  },
                ]}
              >
                <Input
                  addonBefore={contactSelector}
                  placeholder={t("checkout.contact.hint")}
                />
              </Form.Item>
            </Col>
            <Col span={screens.sm ? 12 : 24}>
              <Form.Item
                id="orderer_mobile"
                name="orderer_mobile"
                label={t("checkout.phone.title")}
                rules={[
                  InputRequired(t, "checkout.phone.title"),
                  { min: 8, message: t("error.mobile.limit") },
                ]}
              >
                <Input
                  addonBefore={areaSelector}
                  placeholder={t("checkout.phone.hint")}
                />
              </Form.Item>
            </Col>
            <Col span={screens.sm ? 12 : 24}>
              <Form.Item
                id="orderer_email"
                name="orderer_email"
                label={t("checkout.email.title")}
                rules={[
                  InputRequired(t, "checkout.email.title"),
                  EmailFormat(t),
                ]}
              >
                <Input
                  disabled={useRegisterEmail === true}
                  placeholder={t("checkout.email.hint")}
                />
              </Form.Item>
              <Checkbox
                checked={useRegisterEmail}
                className="register-checkbox"
                onChange={onCheckRegisterEmailChange}
              >
                {t("checkout.email.useregistered")}
              </Checkbox>
            </Col>
          </Row>
        </Card>

        {/* 付款方式 */}
        <Card
          style={{ width: "100%" }}
          variant={"borderless"}
          size={screens.sm ? "default" : "small"}
          title={<div>{t("checkout.paymentmethod.title")}</div>}
        >
          <Row>
            <Col span={24}>
              <Form.Item name="payment_method_code">
                <Select options={paymentOptions} />
              </Form.Item>
            </Col>
          </Row>
        </Card>

        {/* 同意條款 */}
        <div className={styles.checkContainer}>
          <Checkbox
            className={`${isPaymentUnchecked ? styles.red : ""}`}
            checked={checkPaymentAgreement}
            onChange={onAgreementCheckChange}
          >
            <Flex align="center">
              {t("checkout.terms.agreement1")}
              <a href="/guide" target="_blank">
                <P2 color="var(--primary)" style={{ lineHeight: "22px" }}>
                  {t("header.menu.guide")}
                </P2>
              </a>
              {t("checkout.terms.agreement2")}
            </Flex>
          </Checkbox>
          <Checkbox
            className={`${isInfoUnchecked ? styles.red : ""}`}
            checked={checkInfoAgreement}
            onChange={onInfoCheckChange}
          >
            {t("checkout.information.agreement")}
          </Checkbox>
        </div>
        <Button
          className={styles.buttonPay}
          type={"primary"}
          htmlType={"submit"}
          loading={loading}
        >
          {t("checkout.step.pay")}
        </Button>
      </div>
      <Cascader
        options={areaOptions}
        visible={openPopup}
        onClose={() => {
          setOpenPopup(false);
        }}
        value={areaCodeValue}
        onConfirm={handleConfirmAreaCode}
        confirmText={t("normal.confirm")}
        cancelText={t("normal.cancel")}
        placeholder={t("normal.pleaseSelect")}
      />
    </Form>
  );
};

export default Payment;
